import Checkbox from '@mui/material/Checkbox';
import Model from '../models/model'
import Connection from '../services/Connection';
import util from '../util';
import { useGridBase } from '../components/grid/GridBaseContext';
import consts from '../consts';

export const { unitArrayConverter, canPrint, isGridReadOnly, viewOnly, canAdd, isValidFile } = util;

const loadScope = async (...args) => {
	const {
		ManufacturerName,
	} = args[0]

	let where = { "IsDeleted": false };
	if (ManufacturerName) {
		//When ManufacturerName key has a value then its excute 
		where = { ...where, 'ManufacturerName': ManufacturerName }
		return await fetchOperation('ScopeType', where);
	}
}
const fetchOperation = async (comboType, where) => {
	const formData = new FormData();
	formData.append('comboType', comboType);
	formData.append('where', JSON.stringify(where))
	const { options, count } = await fetch(Connection.Combo, {
		method: 'POST',
		body: formData
	}).then((res) => res.json()).then((json) => {
		const { records } = json;
		let options = records?.map((record) => ({
			id: record.LookupId,
			label: record.DisplayValue
		}));
		if (!Array.isArray(options)) {
			options = [];
		}
		return { options: options || [], count: options?.length };
	});
	return { options, count };

}

const setScopeName = ({ formik, value }) => {
	const { ManufacturerName } = formik.values;
	const scopeName = !!ManufacturerName && `${ManufacturerName} ${value}`
	formik.setFieldValue('ScopeName', scopeName)
}

const CustomCheckBox = ({ row }) => {
	const { rowSelectionModel, onRowSelectionModel } = useGridBase();
	const handleOnClick = () => {
		const result = rowSelectionModel.ids.has(row._id);
		if(result)
		{
			rowSelectionModel.ids.delete(row._id);
			onRowSelectionModel(rowSelectionModel);
		}
		else{
			rowSelectionModel.ids.add(row._id);
			onRowSelectionModel(rowSelectionModel);
		}
	}

	const handleChecked = () => {
		return rowSelectionModel.ids.has(row._id);
	}
	return (
		<Checkbox
			checked={handleChecked()}
			onClick={handleOnClick}
			disabled={viewOnly()}
			color="primary"
			value={row?.id}
			inputProps={{ 'aria-label': 'checkbox' }}
		/>
	)
}

export const itemLogColumns = [
	{ field: 'ItemName', headerName: "ItemName", width: 200 },
	{ field: 'ScopeModel', headerName: "ScopeModel", width: 150 },
	{ field: 'SerialNumber', headerName: "SerialNumberSecond", width: 150 },
	{ field: 'Barcodes', headerName: "Barcode", width: 150 },
	{ field: 'RFID', headerName: "RFID", width: 150 },
	{ field: 'status', headerName: "Status", width: 300 },
];

const model = new Model({
	name: 'EndoSetupScope',
	disableAdd: canAdd,
	readOnly: viewOnly,
	allowImport: util.isAllowImport(),
	idProperty: '_id',
	editable: true,
	pageSize: 5,
	gridTitle: 'ItemSync',
	disableExport: false,
	disablePrintBarcode: false,
	disableSelectAll: false,
	defaultSort: 'ModifiedOn DESC',
	showGridRefreshBtn: true,
	gridRefreshInterval: 60000, //Long polling ms,
	importProps: { message: "ScopesCountWarning", maxCount: consts.maxScopesCount, logColumns: itemLogColumns, fileType: consts.endoImportSpec.Scopes.fileType, type: consts.endoImportSpec.Scopes.type },
	formGroups: [{
		fields: [
			'ScopeName',
			'SerialNumber',
			'ManufacturerName',
			'ScopeType',
		]
	}],
	onFormLoad: ({ formik, activeRecord = {} }) => {
		const { ManufacturerName = '', ScopeType = '' } = activeRecord.record || {};
		formik.setFieldValue('ScopeName', `${ManufacturerName} ${ScopeType}`)
	},

	columns: [
		{ field: 'ScopeName', width: 150 },
		{ field: 'ManufacturerName', width: 170, header: 'Manufacturer', lookup: 'ManufacturerName' },
		{ field: 'ScopeType', header: 'scopeType', width: 120, lookup: 'ScopeType', formLookup: loadScope, dependsOn: ['ManufacturerName'], onChange: setScopeName },
		{ field: 'ScopeModel', width: 120, isNotformfield: true, header: 'ScopeModel' },
		{ field: 'IsActive', header: 'Active', type: 'bool', width: 150, isNotformfield: true, },
		{ field: 'SerialNumber', header: 'SerialNumberSecond', width: 150 },
		{ field: 'Department', header: 'Department', width: 120, hidden: true, inputWhen: util.isDepartmentVisible, },
		{ header: 'BarcodeCount', field: 'CodesCount', width: 120, isNotformfield: true, hidden: true },
		{ field: 'ScopePerBasin', header: 'scopePerBasin', width: 160, isNotformfield: true, readonly: true, align: 'right', headerAlign: 'right' },
		{ field: 'UseAlcohol', header: 'UseAlcohol', width: 160, isNotformfield: true, readonly: true, type: 'bool' },
		{ field: 'DataSource', width: 160, isNotformfield: true, hidden: true },
		{ header: 'DefaultBarcode', field: 'DefaultBarcode', width: 150 },
		{ header: 'DefaultRFID', field: 'DefaultRFID', hidden: true, width: 150 },
		{ header: 'Created', field: 'CreatedOn', width: 160, isNotformfield: true, hidden: true, type: 'dateTime', isLocal: true, format: 'MM/DD/YYYY hh:mm:ss A' },
		{ header: 'LastSync', field: 'LastResyncOn', width: 160, isNotformfield: true, hidden: true, type: 'dateTime', isLocal: true, format: 'MM/DD/YYYY hh:mm:ss A' },
		{ field: 'ModifiedOn', header: 'updatedAt', width: 200, isNotformfield: true, type: 'dateTime', isLocal: true, format: 'MM/DD/YYYY hh:mm:ss A' },
		{ field: 'Published', width: 120, type: 'bool', hidden: true, isNotformfield: true, },
		{ header: 'PrintBarcode', field: 'PrintBarcode', type: 'action', width: 120, renderCell: CustomCheckBox, isNotExportField: true },

	]
});
export const EndoSetuScopespModel = model;
export default model.createFormBase();